module.exports = __webpack_public_path__ + "img/seating-gallery-1.5bf14ee3.jpg";